<section
  class="min-h-[calc(100vh-136px)] bg-gray-50 flex items-center justify-center px-4"
>
  <div class="w-full max-w-md bg-white shadow-lg rounded-lg p-6">
    <h2 class="text-xl font-bold text-gray-800 mb-6">Login</h2>
    <form [formGroup]="loginForm" class="space-y-4">
      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Email</mat-label>
        <input matInput formControlName="username" />
      </mat-form-field>

      <mat-form-field appearance="fill" class="w-full">
        <mat-label>Password</mat-label>
        <input matInput type="password" formControlName="password" />
      </mat-form-field>

      <button mat-flat-button color="primary" class="w-full" (click)="login()">
        Log In
      </button>

      <div class="text-red-500 text-sm" *ngIf="errorMessage">
        {{ errorMessage }}
      </div>

      <div class="mt-4">
        <a routerLink="/forgot-password" class="text-[#1565C0] text-sm"
          >Forgot Password?</a
        >
      </div>
    </form>
  </div>
</section>
